import 'leaflet/dist/leaflet.css';
import IndicatorMap from '../../Components/IndicatorMap/IndicatorMap';

export default function Map() {

	return (
		<IndicatorMap />
	)
}
